import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  size?: 'md' | 'lg';
  className?: string;
}
export function CTAButton({
  text,
  onClick,
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'font-orbitron font-bold uppercase tracking-wider rounded-lg transition-all duration-300 bg-[#39FF14] text-black hover:bg-white hover:text-black inline-block text-center';
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-lg md:text-xl' : 'px-6 py-3 text-md';
  const glowClasses = 'shadow-[0_0_20px_rgba(57,255,20,0.6)] hover:shadow-[0_0_30px_rgba(57,255,20,0.9)]';
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('pricing-cta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${glowClasses} ${className}`} data-id="element-32">
      {text}
    </motion.button>;
}